import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import FFOResolver from './FFO';
import DZSResolver from './DZS';
import DNFResolver from './DNF';
import SGResolver from './SG';
import object from '../../../common/object'; // 数据结构需要特殊解析的业务

var ROLE = ['DM', 'DNF', 'R2', 'BEAR', 'PET', 'CF', 'SL', 'X5', 'XJ', 'CHENG', 'SG', 'S', 'QQXY', 'SPEED', '7', 'ROCO', 'FFO', 'HXSJ', 'ZG', 'LOL', 'XXZ', 'MO', '9J', 'LD2', 'QQBABY', 'TNT', 'YL', 'XY', 'CH', '9', 'WCBY', 'X', '3', 'BOSS', 'TTD', 'QQTANG', 'TGAME', 'GF', 'JH', 'QQHX', 'WIN', 'C9', 'YXD', 'SS', 'FIGHT', 'QQSH', '007', 'WF', 'H2', 'TIANTANG', 'TIANTANG2', 'DZS', 'NBA2K', 'XIA', 'WOZ', 'IMONSTER', 'S3', 'BNS', 'BTR', 'NZ', 'FO', 'TPS', 'FF', 'XB', 'ZW', 'BL', 'ZL', '6', 'COS', 'FO4', 'X5M', 'SHIHUN', 'MOYU'];
var resolverMap = {
  FFO: FFOResolver,
  DZS: DZSResolver,
  DNF: DNFResolver,
  SG: SGResolver
}; // 解析角色信息

var _getRoleResult = function _getRoleResult(queryRoleResult, request, charset) {
  var checkparam = queryRoleResult.checkparam,
      md5str = queryRoleResult.md5str,
      data = queryRoleResult.data;
  var map = object.unSerialize(data, 1);

  if (map._webplat_msg_code) {
    if (map._webplat_msg_code * 1 == 1) {
      return {
        iRet: 3,
        // 未查询到角色信息
        sMsg: '在该服务器上未获取到角色信息！',
        arrRole: null
      };
    }

    if (map._webplat_msg_code * 1 != 0) {
      return {
        iRet: 2,
        // 未查询到角色信息
        sMsg: '查询人数过多，请您稍后再来！',
        arrRole: null
      };
    }
  }

  var _arrRole = map.msg || map._webplat_msg;

  if (charset && charset === 'utf8') {
    _arrRole = map._webplat_msg || map.msg;
  }

  if (!_arrRole) {
    return {
      iRet: 3,
      // 未查询到角色信息
      sMsg: '在该服务器上未获取到角色信息！',
      arrRole: null
    };
  }

  _arrRole = _arrRole.split('|');

  if (_arrRole.length == 1) {
    return {
      iRet: 3,
      // 未查询到角色信息
      sMsg: '在该服务器上未获取到角色信息！',
      arrRole: null
    };
  }

  var _arrRoleList = [];

  for (var i = 1; i < _arrRole.length; i++) {
    if (_arrRole[i]) {
      var _oneArray = _arrRole[i].split(' ');

      var _tempobj = {};

      try {
        _tempobj.roleId = decodeURIComponent(_oneArray[0]);
      } catch (e) {
        _tempobj.roleId = _oneArray[0];
      }

      if (_oneArray.length >= 1) {
        try {
          _tempobj.roleName = decodeURIComponent(_oneArray[1]);
        } catch (e) {
          _tempobj.roleName = _oneArray[1];
        }
      }

      if (_oneArray.length >= 2) {
        try {
          _oneArray[2] = decodeURIComponent(_oneArray[2]);
        } catch (e) {
          console.log(e);
        }

        _tempobj.roleSex = _oneArray[2];
        _tempobj.roleJob = _oneArray[2];
      }

      if (_oneArray.length >= 3) {
        try {
          _oneArray[3] = decodeURIComponent(_oneArray[3]);
        } catch (e) {
          console.log(e);
        }

        _tempobj.roleLevel = _oneArray[3];
      }

      _tempobj = _objectSpread(_objectSpread(_objectSpread({}, _tempobj), request), {}, {
        md5str: md5str,
        checkparam: checkparam
      });

      _arrRoleList.push(_tempobj);
    }
  }

  return {
    iRet: 0,
    // 未查询到角色信息
    sMsg: 'OK',
    arrRole: _arrRoleList
  };
};

export default function (gameId) {
  if (ROLE.indexOf(gameId.toUpperCase()) == -1) {
    return _getRoleResult;
  }

  if (resolverMap[gameId.toUpperCase()]) {
    return resolverMap[gameId.toUpperCase()];
  }

  return _getRoleResult;
}